export const GAME_TITLE = 'RLE Guessr'

export const HERO_SECTION_TEXT = 'Guess the mystery RL player'
export const HERO_SECTION_IMAGE_ALT_TEXT = 'RLEsports Guessr'

export const GUESS_GRID_HEADER_NAME_TEXT = 'Name'
export const GUESS_GRID_HEADER_NATIONALITY_TEXT = 'Nat'
export const GUESS_GRID_HEADER_REGION_TEXT = 'Reg'
export const GUESS_GRID_HEADER_TEAM_TEXT = 'Team'
export const GUESS_GRID_HEADER_AGE_TEXT = 'Age'
export const GUESS_GRID_HEADER_LANS_TEXT = 'RLCS Lans'

export const ANSWER_SECTION_IMAGE_ALT_TEXT = 'Player image'

export const FAIL_MODAL_TITLE_TEXT = ['Unfortunate! 😔', 'You Lost! 💀', 'Unlucky! 😢']
export const FAIL_MODAL_BODY_TEXT_1 = 'BETTER LUCK NEXT TIME. COME BACK TOMORROW TO TRY AND GET A NEW STREAK STARTED! 📆'
export const FAIL_MODAL_BODY_TEXT_2 = 'OUR MYSTERY PLAYER OF THE DAY WAS:'
export const FAIL_MODAL_BODY_TEXT_3 = 'Come back tomorrow to try again and start a new streak!'
export const FAIL_MODAL_BUTTON_TEXT = 'SHARE YOUR SCORE'
export const FAIL_MODAL_BUTTON_2_TEXT = 'GLOBAL STATS'
export const FAIL_MODAL_FOOTER_TEXT = 'NEXT RLE GUESSR:'

export const SUCCESS_MODAL_TITLE_TEXT = ['Congratulations! 🎉', 'Well Done! ✨', 'Fantastic! 🥳']
export const SUCCESS_MODAL_BODY_TEXT = 'Come back tomorrow to play again!'
export const SUCCESS_MODAL_BUTTON_TEXT = 'SHARE YOUR SCORE'
export const SUCCESS_MODAL_BUTTON_2_TEXT = 'GLOBAL STATS'
export const SUCCESS_MODAL_FOOTER_TEXT = 'NEXT RLE GUESSR:'

export const SETTINGS_MODAL_HEADER_TEXT = 'Settings ⚙️'
export const SETTINGS_MODAL_CONTRAST_SETTING_NAME_TEXT = 'High Contrast Mode'
export const SETTINGS_MODAL_CONTRAST_SETTING_DESCRIPTION_TEXT = 'Improves colour vision accessibility'

export const FOOTER_HELP_TEXT = 'Info'
export const FOOTER_STATS_TEXT = 'Stats'
export const FOOTER_SETTINGS_TEXT = 'Settings'
